import { createContext } from "react";

export const ConfigContext = createContext({});
export const ThemeContext = createContext({});
export const I18nContext = createContext({});
